(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('rare-reveal-ready');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('rare-is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
  );

  const observeSections = (root = document) => {
    root.querySelectorAll('main .shopify-section:not(.rare-reveal-bound)').forEach((section) => {
      section.classList.add('rare-reveal-bound');
      observer.observe(section);
    });
  };

  const start = () => {
    observeSections();

    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:load', (event) => observeSections(event.target));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
